import React from 'react';
import './Journal.css';

export interface JournalMenuItem {
  key: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  danger?: boolean;
}

interface JournalCellMenuProps {
  position: { top: number; left: number };
  title?: string;
  items: JournalMenuItem[];
  /** Optional custom section rendered above the items (e.g. inline topic editor) */
  extra?: React.ReactNode;
  onClose: () => void;
}

/** Small action popover anchored to a journal cell or column header. */
const JournalCellMenu: React.FC<JournalCellMenuProps> = ({ position, title, items, extra, onClose }) => {
  const menuWidth = 240;
  const left = Math.min(position.left, window.innerWidth - menuWidth - 12);
  const top = Math.min(position.top, window.innerHeight - 60 - items.length * 38);

  return (
    <>
      <div className="journal-menu-backdrop" onClick={onClose} />
      <div className="journal-menu" style={{ top, left, width: menuWidth }}>
        {title && <div className="journal-menu__title">{title}</div>}
        {extra}
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            className={`journal-menu__item ${item.danger ? 'journal-menu__item--danger' : ''}`}
            onClick={item.onClick}
            disabled={item.disabled}
          >
            {item.label}
          </button>
        ))}
      </div>
    </>
  );
};

export default JournalCellMenu;
